export const guardianListData = [
    {
      key: "1",
      id: "GRD0001",
      GuardianImage: "assets/img/guardians/guardian-01.jpg",
      ChildImage: "assets/img/students/student-01.jpg",
      name: "William",
      Addedon: "Added on 25 Mar 2025",
      Child: "Janet",
      class: "Year 3, Jupiter",
      phone: "+6011 82392 37359",
      email: "william@example.com",
    },
    {
      key: "2",
      id: "GRD0002",
      GuardianImage: "assets/img/guardians/guardian-02.jpg",
      ChildImage: "assets/img/students/student-02.jpg",
      name: "Stacey",
      Addedon: "Added on 18 Mar 2025",
      Child: "Joann",
      class: "IV, Mars",
      phone: "+6011 28249 13139",
      email: "stacey@example.com",
    },
    {
      key: "3",
      id: "GRD0003",
      GuardianImage: "assets/img/guardians/guardian-03.jpg",
      ChildImage: "assets/img/students/student-03.jpg",
      name: "George",
      Addedon: "Added on 14 Mar 2025",
      Child: "Kathleen",
      class: "Year 3, Jupiter",
      phone: "+6011 74284 34849",
      email: "george@example.com",
    },
    {
      key: "4",
      id: "GRD0004",
      GuardianImage: "assets/img/guardians/guardian-04.jpg",
      ChildImage: "assets/img/students/student-04.jpg",
      name: "Sarah",
      Addedon: "Added on 27 Feb 2025",
      Child: "Gifford",
      class: "Year 1, Mars",
      phone: "+6011 49230 23294",
      email: "sarah@example.com",
    },
    {
      key: "5",
      id: "GRD0005",
      GuardianImage: "assets/img/guardians/guardian-05.jpg",
      ChildImage: "assets/img/students/student-05.jpg",
      name: "Gary",
      Addedon: "Added on 11 Feb 2025",
      Child: "Lisa",
      class: "Year 2, Mars",
      phone: "+6011 82239 42492",
      email: "gary@example.com",
    },
    {
      key: "6",
      id: "GRD0006",
      GuardianImage: "assets/img/guardians/guardian-06.jpg",
      ChildImage: "assets/img/students/student-06.jpg",
      name: "Linda",
      Addedon: "Added on 24 Jan 2025",
      Child: "Ralph",
      class: "Year 3, Mars",
      phone: "+6011 90139 45835",
      email: "linda@example.com",
    },
    {
      key: "7",
      id: "GRD0007",
      GuardianImage: "assets/img/guardians/guardian-07.jpg",
      ChildImage: "assets/img/students/student-07.jpg",
      name: "Jeffrey",
      Addedon: "Added on 19 Jan 2025",
      Child: "Julie",
      class: "Year 5, Jupiter",
      phone: "+6011 23230 37402",
      email: "jeffrey@example.com",
    },
    {
      key: "8",
      id: "GRD0008",
      GuardianImage: "assets/img/guardians/guardian-08.jpg",
      ChildImage: "assets/img/students/student-08.jpg",
      name: "Galina",
      Addedon: "Added on 08 Jan 2025",
      Child: "Janet",
      class: "Year 3, Jupiter",
      phone: "+6011 91304 34834",
      email: "galina@example.com",
    },
    {
      key: "9",
      id: "GRD0009",
      GuardianImage: "assets/img/guardians/guardian-09.jpg",
      ChildImage: "assets/img/students/student-09.jpg",
      name: "Paul",
      Addedon: "Added on 22 Dec 2024",
      Child: "Susan",
      class: "Year 8, Mars",
      phone: "+6011 84394 28204",
      email: "paul@example.com",
    },
    {
      key: "10",
      id: "GRD0010",
      GuardianImage: "assets/img/guardians/guardian-10.jpg",
      ChildImage: "assets/img/students/student-10.jpg",
      name: "Tracy",
      Addedon: "Added on 15 Jan 2025",
      Child: "Richard",
      class: "Year 7, Mars",
      phone: "+6011 93402 39342",
      email: "tracy@example.com",
    },
    {
      key: "11",
      id: "GRD0010",
      GuardianImage: "assets/img/guardians/guardian-11.jpg",
      ChildImage: "assets/img/students/student-11.jpg",
      name: "Ramos",
      Addedon: "Added on 10 Dec 2024",
      Child: "Veronica",
      class: "Year 9, Jupiter",
      phone: "+6011 57571 74821",
      email: "ram@example.com",
    },
  ];